import { TICKER_ITEMS } from "@/mocks/home";

export default function TickerBar() {
  const doubled = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div className="w-full overflow-hidden bg-foreground-950 text-background-100">
      <div className="flex items-center gap-4 px-4 py-1.5 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 text-xs font-black uppercase tracking-wider text-accent-300">
          <i className="ri-flashlight-fill text-sm" />
          速览
        </span>
        <div className="relative flex-1 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_6%,black_94%,transparent)]">
          <div className="ticker-track flex w-max items-center gap-10">
            {doubled.map((t, i) => (
              <span key={i} className="flex items-center gap-3 whitespace-nowrap text-xs text-background-200/90">
                {t}
                <i className="ri-arrow-right-s-line text-background-500" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}